import React from "react";
import {
  List,
  DatagridConfigurable,
  TextField,
  BooleanField,
  DateField,
  NumberField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  useListContext,
  RaRecord,
  Identifier,
} from "react-admin";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton label="Create Voting Event" />
  </TopToolbar>
);

const VotingEventsTitle = () => {
  const { defaultTitle } = useListContext();
  return <span>{defaultTitle || "Voting Events"}</span>;
};

// Add Empty State Component
const Empty = () => (
  <Box textAlign="center" m={5}>
    <Typography variant="h5" paragraph color="textSecondary">
      No voting events yet
    </Typography>
    <Typography variant="body1" color="textSecondary" paragraph>
      Create your first voting event to get started
    </Typography>
    <CreateButton
      variant="contained"
      label="Create Voting Event"
      icon={<AddIcon />}
    />
  </Box>
);

const VotingEventsList = () => (
  <List
    resource="votingEvents"
    perPage={25}
    actions={<ListActions />}
    title={<VotingEventsTitle />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    empty={<Empty />}
  >
    <DatagridConfigurable
      rowClick={(id: Identifier) => `/votingEvents/${id}/edit`}
      bulkActionButtons={false}
      omit={['startDate', 'endDate', 'votesPerUser', 'createdAt']}
    >
      <TextField source="title.text" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="startDate" showTime />
      <DateField source="endDate" showTime />
      <NumberField source="votesPerUser" label="Votes/User" />
      <DateField source="createdAt" label="Created" />
    </DatagridConfigurable>
  </List>
);

export default VotingEventsList;